// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"dab33565","290":"0a2a0cea","309":"789f6e63","488":"2f67def3","580":"81439383","610":"2f5e9485","614":"cfac6e3d","635":"c07cdd6f","776":"8d46b07f","927":"cae8029c"}[chunkId] + ".chunk.js";
};